// Third party libraries
import _ from 'lodash';
import React from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import { Button, Form, Header } from 'semantic-ui-react';

// Components
import CustomInput from '../../../../../components/form/input';

// Models
import PaymentModel from '../../../../../../data/models/payment/payment';

// Validations
import { required } from '../../../../../../config/validations';

// Locales
import I18n from '../../../../../../i18n';

class ProPlanForm extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
        
    }

  }

  onSubmit = async data => {

    const tempForm = { ...data };
    const self = this;
    const message = {
        headerTitle: "Error",
        title: '',
        buttons: [{
            text: I18n.t('actions.accept'),
            callback: () => self.props.closeModal()
        }]
    };

    tempForm.monthlyPrice = parseFloat(tempForm.monthlyPrice);
    tempForm.annualPrice = parseFloat(tempForm.annualPrice);
    tempForm.maxStudents = parseInt(tempForm.maxStudents);

    try {

      this.props.openLoader();

      if(tempForm._id) {

        await PaymentModel.updateProPlan(tempForm._id, _.omit(tempForm, ['_id']));

      } else {

        await PaymentModel.createProPlan(tempForm);

      }

      this.props.history.push('/home/pro/plans');
        
    } catch (error) {

      message.title = I18n.t('practice.anErrorOcurred') + ' ' + _.get(error, 'error', error);
      this.props.openModal(message);
        
    } finally {

      this.props.closeLoader();

    }

  }

  render() {
    return (
      <Form noValidate onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <Header as='h3'>{ I18n.t('plans.general') }</Header>
        <Form.Group widths='equal'>
            <Field
                component={ CustomInput }
                placeholder={ I18n.t('plans.name') }
                name="name"
                label={ I18n.t('plans.name') }
                validate={ [required] }
            />
            <Field
                component={ CustomInput }
                placeholder={ I18n.t('plans.maxStudents') }
                name="maxStudents"
                label={ I18n.t('plans.maxStudents') }
                validate={ [required] }
                type='number'
                restrictions={ [{ numeric: true, canBeFloat: false }] }
            />
        </Form.Group>
        <Form.Group widths='equal'>
            <Field
                component={ CustomInput }
                placeholder={ I18n.t('plans.monthlyPrice') }
                name="monthlyPrice"
                label={ I18n.t('plans.monthlyPrice') }
                validate={ [required] }
                type='number'
                restrictions={ [{ numeric: true, canBeFloat: true }] }
            />
            <Field
                component={ CustomInput }
                placeholder={ I18n.t('plans.annualPrice') }
                name="annualPrice"
                label={ I18n.t('plans.annualPrice') }
                validate={ [required] }
                type='number'
                restrictions={ [{ numeric: true, canBeFloat: true }] }
            />
            <Field
                component={ CustomInput }
                placeholder={ I18n.t('plans.logoUrl') }
                name="logo"
                label={ I18n.t('plans.logo') }
            />
        </Form.Group>
        <Button type='submit' primary>{ I18n.t('actions.save') }</Button>
        <Button type='button' onClick={ () => this.props.history.push('/home/pro/plans') }>{ I18n.t('actions.cancel') }</Button>
      </Form>
    )
  }
}

const validate = (values) => {

    const errors = {};

    if (values.maxStudents < 0) {
      errors.maxStudents = "El valor no puede ser menor que 0";
    }

    if (values.monthlyPrice < 0) {
      errors.monthlyPrice = "El valor no puede ser menor que 0";
    }

    if (values.annualPrice < 0) {
      errors.annualPrice = "El valor no puede ser menor que 0";
    }

  return errors;

};

ProPlanForm = connect(state => {

    const reduxFormState = _.cloneDeep(_.get(state, 'form.proPlanForm.values', {}));

    return {
        reduxFormState
    };

})(ProPlanForm);

export default reduxForm({
    form: 'proPlanForm',
    touchOnBlur: true,
    touchOnChange: true,
    validate
})(connect(null, {})(ProPlanForm));